import { ActionBar } from '@dreryk/react-components';

import { MagistralDrugTemplates } from '~legacy.visit';
import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

export const MagistralDrugTemplatesTabContent = (): JSX.Element => {
   return (
      <ActionBar testId={'magistralDrugTemplates'} id={'magistralDrugTemplates'}>
         <MagistralDrugTemplates
            editSlot={({ handleSubmit, ready, onTemplateSaveSuccess }) => (
               <>
                  <MagistralDrugTemplates.SendTemplateButton
                     handleSubmit={handleSubmit}
                     onSuccess={onTemplateSaveSuccess}
                     disabled={ready}
                  />
                  <FormsTemplates.CancelActionBarPrimaryLink />
               </>
            )}
         />
      </ActionBar>
   );
};
